"use client";

import { START_TIMING_OPTIONS, startDateInputBounds } from "@/features/leads/shared/start-timing";
import { StepHeading } from "@/features/quote/ui/StepHeading";
import { StepNav } from "@/features/quote/ui/StepNav";
import { useStep, useWizard } from "@/features/quote/ui/wizard-context";
import { fieldBaseClass, labelClass } from "@/shared/ui/form/field-styles";
import { RadioCards } from "@/shared/ui/form/RadioCards";

export function StartStep() {
  const { autoAdvance, next, back, canAdvance, isRecurring: recurring } = useWizard();
  const [{ startTiming = "", startDate = "" }, answer] = useStep("start");
  const needsDate = startTiming === "SPECIFIK_DATO";
  const dateBounds = startDateInputBounds();

  return (
    <section>
      <StepHeading
        title={recurring ? "Hvornår skal rengøringen starte?" : "Hvornår skal opgaven løses?"}
        body={
          recurring
            ? "Så kan firmaet give dig et tilbud med en start, der passer dig."
            : "Så kan firmaet give dig et tilbud på et tidspunkt, der passer dig."
        }
        maxW="max-w-[24ch]"
      />
      <RadioCards
        options={START_TIMING_OPTIONS}
        value={startTiming}
        onChange={(v) => {
          answer({ startTiming: v });
          if (v !== "SPECIFIK_DATO") autoAdvance();
        }}
        gridClassName="grid-cols-2 sm:grid-cols-3"
      />

      {needsDate && (
        <div className="mt-6">
          <label htmlFor="wiz-start-date" className={labelClass}>
            Dato
          </label>
          <input
            id="wiz-start-date"
            type="date"
            min={dateBounds.min}
            max={dateBounds.max}
            value={startDate}
            onChange={(e) => answer({ startDate: e.target.value })}
            className={`${fieldBaseClass} max-w-56`}
          />
          <p className="mt-2 text-[13px] text-ink-subtle">
            Kender du ikke den præcise dag, så vælg den første dag der kunne passe.
          </p>
        </div>
      )}

      <StepNav onBack={back} onNext={next} nextEnabled={canAdvance} nextLabel="Næste →" />
    </section>
  );
}
